module.exports = __webpack_public_path__ + "static/media/26UNRWA3.3b8a8a69.jpg";